<template>
  <div class="graph" ref="target"></div>
</template>

<script>
import { BarChart } from "@/plugins/echarts_bank/index";
export default {
  props: {
    dataList: {
      type: Array,
      required: true
    },
    commonFont: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      graph: null,
      colors: ["#2573D9"]
    };
  },
  mounted() {
    const basicSize = this.commonFont;
    this.graph = new BarChart({
      ele: this.$refs.target,
      fontSize: basicSize,
      palletColors: this.colors,
      barBorderRadius: 3,
      transUnit: 10000,
      grid: {
        top: 1 * basicSize,
        bottom: -0.5 * basicSize
      },
      xAxis: {
        axisLabel: {
          // interval: 0,
          rotate: 30,
          margin: 1 * basicSize,
          fontSize: basicSize,
          lineHeight: 1.2 * basicSize,
          formatter: function (e) {
            return e.slice(0, 4) + "\n" + e.slice(4);
          }
        }
      },
      series: [
        {
          type: "bar",
          name: "数量",
          barWidth: "40%",
          barGap: 0
        }
      ]
    });
    this.create();
  },
  methods: {
    create() {
      const data = this.dataList;
      this.graph.setData([data]).draw();
    }
  }
};
</script>

<style></style>
